export enum Events {
  REFRESH_ACCOUNT_KPI = 'refresh_kpi'
}